<template>
 <Head>
    <title> Admin Competency Matrix Render | {{$page.props.appName}}</title>
    <meta name="description" :content="'Competency Matrix Render ' + $page.props.appName">
  </Head>
  <div class="p-3">
    <div class="bg-gray-100 rounded-md shadow overflow-hidden max-w-full p-3 overflow-x-auto overflow-y-auto">
        <h1 class="text-2xl font-semibold ml-1">Competency Matrix</h1>
        <p class="ml-1 text-sm mb-1">Showing {{staff.length}} user(s) and {{skills.length}} skill(s)</p>
        <Link href="/admin/reports/compmatrix" class="cursor-pointer font-semibold text-black text-sm ml-1 text-white bg-black rounded p-2 mt-2">Search again</Link>
         <table v-if="staff.length>0" class="ml-1">
           <thead>
             <th class="p-2">Surname</th>
             <th class="p-2">First Name</th>
             <th class="p-2">Site</th>
             <th class="p-2">Department</th>
             <th v-for="skill in skills" :key="skill.id" class="p-2">{{skill.skill_name}}</th>
           </thead>
           <tbody>
             <Link as="tr" v-for="s in staff" :key="s.id" :href="'/admin/skills/' + s.id" class="bg-white cursor-pointer hover:bg-gray-200">
               <td class="text-center border border-black font-medium px-3 py-2 text-black">{{s.surname}}</td>
                <td class="text-center border border-black font-medium px-3 py-2 text-black">{{s.first_name}}</td>
                <td class="text-center border border-black font-medium px-3 py-2 text-black">{{s.site}}</td>
                <td class="text-center border border-black font-medium px-3 py-2 text-black">{{s.department}}</td>
                <td class="text-center border border-black font-medium px-3 py-2 text-black" v-for="(skill,k) in staffskills[s.id]" :key=k :class="handleSkillStyle(skill)"> 
                    {{handleSkill(skill)}}
                </td>
             </Link>
           </tbody>
         </table>
         <div v-else class="ml-5 p-1">
           <p>No staff could be found for your filter choices, try and go back and select a different department or site.</p>
         </div>
    
    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Pagination from "@/Shared/Pagination";
import { Link } from "@inertiajs/inertia-vue3";
import moment from 'moment';
import { Head } from '@inertiajs/inertia-vue3'

export default {
  layout: Layout,
  components: { Link, Pagination,Head},
  props: {
    sites: Object,
    departments: Object,
    skills : Object,
    staff : Object,
    staffskills : Object
  },
  data() {
    return {
     
    };
  },
  methods: {
    handleSkill(skill){
      if(skill==null){
        return "Not allocated";
      }else {
         let now = moment()
         let date = moment(skill)
         var diff = now.diff(date,'days');
        if (diff > 0) {
                return 'Expired';
            } else if (diff >= -90) {
                return 'Pending Expiry';
            } else {
                return 'In date';
            }
      }
    },
    handleSkillStyle(skill){
      if(skill==null){
        return "text-xs text-center";
      }else {
         let now = moment()
         let date = moment(skill)
         var diff = now.diff(date,'days');

        if(diff>0){
              return 'bg-red-400 text-center';
         } else if (diff >= -90) {
              return 'bg-yellow-400 text-center';
            } else {
            return 'bg-green-400 text-center';
        }
      }
    },
    store() {
      this.form.post("/admin/reports/compmatrix");

    }
  },
};
</script>
     